(function () {
  'use strict';

  var formSelector = '.js-naellia-newsletter-form';

  function getButton(form) {
    return form.querySelector('button[type="submit"]');
  }

  function setBusy(form, busy) {
    var button = getButton(form);
    if (!button) return;

    if (!button.dataset.originalLabel) {
      button.dataset.originalLabel = button.textContent.trim();
    }

    button.disabled = busy;
    button.setAttribute('aria-busy', busy ? 'true' : 'false');
    button.textContent = busy ? 'Joining…' : button.dataset.originalLabel;
    form.classList.toggle('is-loading', busy);
  }

  function setError(form, message) {
    var error = form.querySelector('[data-newsletter-error]');
    if (!error) return;

    error.textContent = message || 'We could not add you right now. Please try again.';
    error.hidden = false;
    error.classList.add('is-visible');
  }

  function clearError(form) {
    var error = form.querySelector('[data-newsletter-error]');
    if (!error) return;

    error.hidden = true;
    error.classList.remove('is-visible');
    error.textContent = '';
  }

  function showSuccess(form) {
    var fields = form.querySelector('[data-newsletter-fields]');
    var status = form.querySelector('[data-newsletter-success]');

    clearError(form);
    form.reset();

    if (fields) fields.hidden = true;
    if (status) {
      status.hidden = false;
      status.classList.add('is-visible');
      try {
        status.focus({ preventScroll: true });
      } catch (error) {
        status.focus();
      }
    }

    form.classList.add('is-success');
  }

  function extractServerState(html, formId) {
    var parser = new DOMParser();
    var documentResponse = parser.parseFromString(html, 'text/html');
    var returnedForm = formId ? documentResponse.getElementById(formId) : null;

    if (!returnedForm) {
      returnedForm = documentResponse.querySelector(formSelector);
    }

    if (!returnedForm) {
      return { success: false, error: '' };
    }

    var success = returnedForm.querySelector('[data-newsletter-success].is-visible:not([hidden])');
    var error = returnedForm.querySelector('[data-newsletter-error].is-visible:not([hidden]), .errors');

    return {
      success: Boolean(success),
      error: error ? error.textContent.replace(/\s+/g, ' ').trim() : ''
    };
  }

  document.addEventListener('submit', function (event) {
    var form = event.target.closest(formSelector);
    if (!form || event.defaultPrevented || form.dataset.submitting === 'true') return;

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    event.preventDefault();
    clearError(form);
    form.dataset.submitting = 'true';
    setBusy(form, true);

    var request = fetch(form.action, {
      method: 'POST',
      body: new FormData(form),
      credentials: 'same-origin',
      redirect: 'follow',
      headers: {
        Accept: 'text/html',
        'X-Requested-With': 'XMLHttpRequest'
      }
    });

    request
      .then(function (response) {
        return response.text().then(function (html) {
          return { response: response, html: html };
        });
      })
      .then(function (result) {
        var response = result.response;
        var state = extractServerState(result.html, form.id);
        var successInUrl = response.url.indexOf('customer_posted=true') !== -1;

        if (response.url.indexOf('/challenge') !== -1) {
          form.dataset.submitting = 'native';
          HTMLFormElement.prototype.submit.call(form);
          return;
        }

        if (!response.ok || state.error) {
          throw new Error(state.error || 'We could not add you right now. Please try again.');
        }

        if (state.success || successInUrl || response.ok) {
          showSuccess(form);
        }
      })
      .catch(function (error) {
        setError(form, error && error.message ? error.message : 'We could not add you right now. Please try again.');
      })
      .finally(function () {
        if (form.dataset.submitting !== 'native') {
          form.dataset.submitting = 'false';
          setBusy(form, false);
        }
      });
  });
})();
